function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.941177%,12.941177%,12.941177%)",
      fillOpacity: 1
    },
    d: "M 35.515625 39.949219 L 4.484375 39.949219 C 2.035156 39.949219 0.0507812 37.964844 0.0507812 35.515625 L 0.0507812 4.484375 C 0.0507812 2.035156 2.035156 0.0507812 4.484375 0.0507812 L 35.515625 0.0507812 C 37.964844 0.0507812 39.949219 2.035156 39.949219 4.484375 L 39.949219 35.515625 C 39.949219 37.964844 37.964844 39.949219 35.515625 39.949219 Z M 35.515625 39.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.367188 31.082031 L 24.234375 31.082031 L 8.726562 8.917969 L 15.863281 8.917969 Z M 25.082031 29.203125 L 27.925781 29.203125 L 15.011719 10.796875 L 12.171875 10.796875 Z M 25.082031 29.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.984375 31.082031 L 18.96875 21.835938 L 17.925781 20.449219 L 8.71875 31.082031 Z M 10.984375 31.082031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.5 17.472656 L 21.5 18.902344 L 30.125 8.917969 L 27.910156 8.917969 Z M 20.5 17.472656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterX);
export default __webpack_public_path__ + "static/media/icon-twitter-x.6425bd406021df579d17b16f2e363c40.svg";
export { ForwardRef as ReactComponent };